import { Link } from 'react-router-dom';

const HeroView = ({ hero, onClick, selected }) => {
  const name = `${hero.lastName || ''}${hero.firstName || ''}`;
  const details = [hero.birthYear && `${hero.birthYear}년생`, hero.gender === 'M' ? '남자아이' : hero.gender === 'F' ? '여자아이' : ''].filter(Boolean);

  return <article className={`hero-profile${selected ? ' is-selected' : ''}`}>
    <button type="button" className="hero-profile-select" aria-label={`${name} 주인공으로 선택`} aria-pressed={selected} onClick={() => onClick(hero.heroNo)}>
      <span className="hero-profile-portrait">
        <img src={hero.graphicImageUrl || hero.imageUrl || '/image/no_profile_image.png'} alt="" />
      </span>
      <span className="hero-profile-info">
        <span className="hero-profile-status">{selected ? '지금 선택한 주인공' : '이야기를 기다리는 주인공'}</span>
        <strong>{name}</strong>
        {details.length > 0 && <span className="hero-profile-details">{details.join(' · ')}</span>}
      </span>
      <span className="hero-profile-check" aria-hidden="true">{selected ? '✓' : ''}</span>
    </button>
    <div className="hero-profile-footer">
      <span>아이를 더 알려주세요</span>
      <Link to={`/heroes/${hero.heroNo}/setting`} aria-label={`${name} 주인공 설정`}>주인공 설정 <span aria-hidden="true">→</span></Link>
    </div>
  </article>
};

export default HeroView;
